import { ElementRef, Renderer2 } from '@angular/core';
var ImageComponent = /** @class */ (function () {
    function ImageComponent(renderer) {
        this.renderer = renderer;
        this.loading = false;
        this.alternativeText = "Image";
        this.width = 340;
        this.height = 225;
        this.text = 'No Image';
        this.bgColor = '#f7f7f7';
    }
    Object.defineProperty(ImageComponent.prototype, "encodedText", {
        get: function () {
            return encodeURI(this.text);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ImageComponent.prototype, "imageStyle", {
        get: function () {
            return this.loading ? 'hidden' : 'visible';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ImageComponent.prototype, "scale", {
        get: function () {
            return this.width / this.height;
        },
        enumerable: true,
        configurable: true
    });
    // ngOnChanges() {
    //   this.loading = true
    // }
    // ngAfterViewInit() {
    //   if(window) {
    //     let width = Number(window.getComputedStyle(this.loaderRef.nativeElement)
    //       .width.replace('px', ''))
    //     this.renderer.setStyle(
    //       this.loaderRef.nativeElement, 'height', (width / this.scale) + 'px'
    //     )
    //   }
    // }
    ImageComponent.prototype.loaded = function (event) {
        this.loading = false;
    };
    ImageComponent.prototype.placeholder = function (event) {
        //this.loading = true
        event.target.src = "https://via.placeholder.com/" + this.width + "x" + this.height + "/f7f7f7?text=" + this.encodedText;
    };
    return ImageComponent;
}());
export { ImageComponent };
